import React from 'react';
import { setCurrentView } from 'core/utils';
import { ProductDetailViewStore } from 'modules/product/stores';
import { ProductDetailTemplate } from 'themes/modules/product/pages';

@setCurrentView(rootStore => new ProductDetailViewStore(rootStore), 'productDetailViewStore')
class ProductDetail extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ProductDetailTemplate {...this.props} />;
	}
}

export default ProductDetail;
